import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
@Component({
  selector: 'app-user-membership',
  templateUrl: './user-membership.component.html',
  styleUrls: ['./user-membership.component.css']
})
export class UserMembershipComponent implements OnInit {
  @ViewChild('callAPIDialog', { static: false }) callAPIDialog: TemplateRef<any>;
  isbrowseChapterSelected = true;
  ismyMembershipSelected = false;
  siteList: any = [];
  siteId: any;
  siteName: string;
  ergList: any = [];
  regularErgList: any = [];
  virtualErgList: any = [];
  selectedErg: any = [];
  loginData = JSON.parse(localStorage.getItem('loginData'));
  userId: any = this.loginData['userId'];
  enrolledErg: any = [];
  removeMemberships: any = [];
  userEmail : any = sessionStorage.getItem('emailAddressForMembership');
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  emailAddress = '';
  isEmailInvalid = false;
  noErgsFound: boolean;
  noMembershipsFound = false;
  method: string;
  param: string;
  param1: string;
  msg: string;
  emailSent = false;
  ownSite: boolean;
  membershipsUpdated = false;
  regularMembershipsExists: boolean;
  virtualMembershipsExists: boolean;
  isEmailEditable = false;
  editEmailAllowed: boolean;
  isDefaultSite: boolean;
  ergSiteList: any[];
  selectedChapter: any;
  disableButton: boolean;
  virtualMembershipErgIdSelected: any;
  constructor(
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly  selfService: SelfService,
    private readonly adminService: BpgAdminServices,
    private readonly dialog: MatDialog,
    private readonly bpgCommonService: BpgCommonService
    ) { }

  ngOnInit() {
    if (this.userEmail === "" || this.userEmail === null || this.userEmail === undefined ||
      !(this.userEmail.endsWith('@toyota.com') || this.userEmail.endsWith('@lexus.com') || this.userEmail.endsWith('@scion.com'))) {
      this.isEmailEditable = true;
    }
    this.logUserAction();
    this.getEnrolledErgs();
    this.getRegularAndVirtualErgs();
  }
  getRegularAndVirtualErgs()
  {
    this.spinner.show();
    this.selfService.getVirtualBpgs(this.userId).subscribe(data => {
      this.spinner.hide();
      if(data!=null && data!==undefined)
      {
       if(data['regularMemberships'])
       {
          const regularMemberships =  data['regularMemberships']
          if(regularMemberships.bpgList)
          {
            this.regularErgList = regularMemberships.bpgList;
            this.siteId = regularMemberships.siteId;
            this.siteName = regularMemberships.siteName;
            this.isDefaultSite = this.siteName === 'DEFAULT SITE LOCATION' ;
            if(this.regularErgList.length > 0)
            {
              this.regularErgList.map(res => {
                        res.siteId = this.siteId;
                        res.siteName = this.siteName;
    
                      })
            }

          }

       }
       if(data['virtualMemberships'])
       {
        this.virtualErgList =  data['virtualMemberships']
             }
      }
    })

  }
  selectChapter(data){
    this.disableButton = true;
    const bpg = JSON.parse(JSON.stringify(data));
    this.virtualErgList.map(res => {
      if(res.bpgId === bpg.bpgId){
        res.checked = true;
      }
    })
    this.virtualMembershipErgIdSelected = bpg.bpgId;
    this.ergSiteList = [];
    this.ergSiteList = bpg.siteDetails;
    this.ergSiteList.forEach(res => {
       res.bpgId = bpg.bpgId;
       res.bpgName = bpg.bpgName;
    })
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minHeight = "30vh";
    dialogConfig.maxHeight = "60vh";
    dialogConfig.width = "50vw";
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
    dialogRef.updatePosition({
      top: '27vh'
    })
  }

  toggleRadio(data){
    this.disableButton = false;
    this.selectedChapter = data;
  }

  confirmVirtualMembership(){
    this.selectedErg.map(res=>{
      if(res.bpgName === this.selectedChapter.bpgName){
        this.selectedErg.splice(this.selectedErg.indexOf(res),1);
      }
    })
    this.virtualErgList.map(res => {
      if(res.bpgId === this.selectedErg.bpgId){
        res.checked = true;
      }
    })
    this.selectedErg.push(this.selectedChapter);
    this.dialog.closeAll();
  }
  closePopup(){
    this.virtualErgList.map(res=>{
      if(res.bpgId === this.virtualMembershipErgIdSelected){
              res.checked = false;
      }
    })
    this.dialog.closeAll();
  }
 
  getEnrolledErgs() {
    this.noMembershipsFound = false;
    this.selfService.getEnrolledBpg(this.userId).subscribe(data => {
      if (data != null && data !== undefined) {
        if (data.length === 0) {
          this.noMembershipsFound = true;
        }
        else {
          this.enrolledErg = data;
          this.enrolledErg.map(res => {
            res.viewSite = true;
            if (res.isBaseSite) {
              this.regularMembershipsExists = true;
            } else {
              this.virtualMembershipsExists = true;
            }
          })
        }
      }
    }
    )
  }

  removeMembership(data, data1) {
    this.method = "onRemoveMembership";
    this.param = data;
    this.param1 = data1;
    this.msg = " Are you sure you want to cancel the membership ? ";
  }

  onRemoveMembership() {
    this.enrolledErg.map(sample3 => {
      if (sample3.siteId === this.param1) {
        const sample2 = sample3.bpgList.filter(list => list.bpgId === this.param);
        sample3 = {
          ...sample3,
          bpgList: sample2
        }
        this.removeMemberships.push(sample3)
      }

    })
    this.enrolledErg = this.enrolledErg.map(sample => {
      if (sample.siteId === this.param1) {
        const sample1 = sample.bpgList.filter(list => list.bpgId !== this.param);
        sample = {
          ...sample,
          bpgList: sample1
        }
      }
      return sample
    })
    this.regularMembershipsExists = false;
    this.virtualMembershipsExists = false;
    this.enrolledErg.map(res => {
      if (res.isBaseSite && res.bpgList.length > 0) {
        this.regularMembershipsExists = true;
      }
      if (!res.isBaseSite && res.bpgList.length > 0) {
        this.virtualMembershipsExists = true;
      }
    })
  }
  showHideChapterMembership(data) {
    this.enrolledErg.map(res => {
      if (res.siteName === data) {
        res.viewSite = !res.viewSite
      }
    })
  }
  /** to select the checkbox
 * @class BpgListComponent
 * @method toggleCheckbox
 */
  toggleCheckbox(event, data , regularOrVirtual) {
    const bpg = JSON.parse(JSON.stringify(data));
    if (event.target.checked) {
      if(regularOrVirtual === 'regular')
      {
        this.selectedErg.push(bpg);
        this.regularErgList.map(a => {
        if (a.bpgName === bpg.bpgName) {
          Object.assign(a, {
            'showLeadership': true,
            'siteId': this.siteId,
            'siteName': this.siteName
          })
        }
      })
      this.selectedErg.map(res => {
        if (bpg.bpgId === res.bpgId && res.siteId === this.siteId) {
          res.chair = false;
          res.viceChair = false;
          res.communicationChair = false;
          res.financeChair = false;

        }
      })
      } else{
        this.selectChapter(bpg);
      }

    } else {
      let index = -1;
      this.selectedErg.map(res => {
        if (data.bpgId === res.bpgId) {
          index = this.selectedErg.indexOf(res);
        }
      })
      if (index !== -1) {
        this.selectedErg.splice(index, 1);
        if(regularOrVirtual === 'regular')
        { 
          this.regularErgList.map(a => {
          if (a.bpgName === bpg.bpgName) {
            Object.assign(a, {
              'showLeadership': false,
              'siteId': this.siteId,
              'siteName': this.siteName
            })
          }
        })
        this.regularErgList.map(res => {
          if (data.bpgId === res.bpgId && res.siteId === this.siteId) {
            res.chair = false;
            res.viceChair = false;
            res.communicationChair = false;
            res.financeChair = false;

          }
        })
        }
        else{
          this.virtualErgList.map(res => {
            if(res.bpgId === bpg.bpgId){
              res.checked = false;
            }
          })
        }
      }

    }
  }
  /** email validation
 * @class ChapterComponent
 * @method checkEmailType
 */
  checkEmailType(event) {
    if (event.target.value !== "") {
      const re = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/);
      if (re.test(String(event.target.value).toLowerCase()) === false) {
        this.isEmailInvalid = true;
      } 
      else {
        this.isEmailInvalid = false;
      }
    }
    else {
      this.isEmailInvalid = false;
    }
  }
  updateEmail() {
    this.createdDateTime = new Date();
    this.modifiedDateTime = new Date();
    const landingData = {
      "userId": this.userId,
      "personalemailId": this.emailAddress,

    }

    this.adminService.updateMembershipEmail(landingData).subscribe(data => {
      if (data != null && data !== undefined) {
        this.emailSent = true;
        this.userEmail = this.emailAddress;
        this.editEmailAllowed = false;
        setTimeout(function () {
          this.emailSent = false;
        }.bind(this), 2500);
      }
    })
  }
  browseChapters() {
    this.isbrowseChapterSelected = true;
    this.ismyMembershipSelected = false;

  }
  myMemberships() {
    this.isbrowseChapterSelected = false;
    this.ismyMembershipSelected = true;
  }
  selectChapterMembership(bpg, data, _virtualOrRegular) {

    this.selectedErg.map(res => {

      if (res.bpgId === bpg.bpgId && res.siteId === this.siteId) {
        if (data === 'chair') {
          res.chair = !res.chair
        }
        if (data === 'viceChair') {
          res.viceChair = !res.viceChair

        }
        if (data === 'financeChair') {
          res.financeChair = !res.financeChair
        }
        if (data === 'communicationChair') {
          res.communicationChair = !res.communicationChair
        }
      }

    })
    this.regularErgList.map(res => {

      if (res.bpgId === bpg.bpgId && res.siteId === this.siteId) {
        res.siteName = this.siteName;
        if (data === 'chair') {
          res.chair = !res.chair
        }
        if (data === 'viceChair') {
          res.viceChair = !res.viceChair

        }
        if (data === 'financeChair') {
          res.financeChair = !res.financeChair
        }
        if (data === 'communicationChair') {
          res.communicationChair = !res.communicationChair
        }
      }

    })
  }
  undoRemoveMembership(bpg, siteId) {

    this.enrolledErg = this.enrolledErg.map(sample => {
      if (sample.siteId === siteId) {
        sample.bpgList.push(bpg);

      }
      return sample
    })
    this.removeMemberships = this.removeMemberships.map(sample => {
      if (sample.siteId === siteId) {
        const sample1 = sample.bpgList.filter(list => list.bpgId !== bpg.bpgId);
        sample = {
          ...sample,
          bpgList: sample1
        }
      }
      return sample

    })
    this.removeMemberships = this.removeMemberships.filter(res =>
      res.bpgList.length > 0

    )
    this.regularMembershipsExists = false;
    this.virtualMembershipsExists = false;
    this.enrolledErg.map(res => {
      if (res.isBaseSite && res.bpgList.length > 0) {
        this.regularMembershipsExists = true;
      }
      if (!res.isBaseSite && res.bpgList.length > 0) {
        this.virtualMembershipsExists = true;
      }
    })

  }

  editEmail() {
    this.editEmailAllowed = true;
    this.emailAddress = this.userEmail;
  }

  saveMembership() {
    this.spinner.show();
    const submitData = {
      userId: this.userId,
      'addMembership': this.selectedErg,
      'removeMembership': this.removeMemberships
    }
    this.selfService.saveMembership(submitData).subscribe(data => {
      if (data != null && data !== undefined) {
        this.spinner.hide();
        this.membershipsUpdated = true;
        this.selectedErg = [];
        this.removeMemberships = [];
        this.getEnrolledErgs();
        this.getRegularAndVirtualErgs();
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.membershipsUpdated = false;
          this.ismyMembershipSelected = true;
          this.isbrowseChapterSelected = false;
        }, 1000);
      }
    })

  }
  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Membership Application"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }
}
